import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";

export * from "./types";

const ENDPOINTS = {
  TRANSCRIPTION_STREAM:
    "/api/v2/org/:organization_id/user/:user_id/transcription-stream",
};

/** Negotiated subprotocol; must match zensei-api livetranscription.WebSocketSubprotocol. */
export const TRANSCRIPTION_STREAM_WS_PROTOCOL = "zensei.transcription.v1";

const WS_BEARER_SUBPROTOCOL_PREFIX = "bearer.";

/**
 * Opens a live transcription stream. Binary frames carry raw 16kHz mono PCM16
 * mic audio up; JSON text frames carry transcript/control messages down.
 * Browsers cannot set Authorization on the upgrade request, so the JWT is sent
 * in Sec-WebSocket-Protocol instead of the URL.
 */
export function createTranscriptionStreamWebSocket(
  url: string,
  accessToken: string,
): WebSocket {
  const socket = new WebSocket(url, [
    TRANSCRIPTION_STREAM_WS_PROTOCOL,
    `${WS_BEARER_SUBPROTOCOL_PREFIX}${accessToken}`,
  ]);
  socket.binaryType = "arraybuffer";
  return socket;
}

export class TranscriptionStreamAPI {
  constructor(private client: CohesiveAPIClient) {}

  async getStreamUrl(): Promise<string> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    return (
      this.client.axios.defaults.baseURL?.replace(/^http/, "ws") +
      route(ENDPOINTS.TRANSCRIPTION_STREAM, {
        organization_id: organizationId,
        user_id: userId,
      })
    );
  }
}
